// ============= Imports =============
import React from 'react';
import { VisualPromptCard } from '../VisualPromptCard';
import type { VisualPromptCardGridProps } from './types';

// ============= Component =============
export const VisualPromptCardGrid: React.FC<VisualPromptCardGridProps> = ({
  prompts,
  onSelectPrompt,
  onDeletePrompt,
  onToggleFeatured,
}) => (
  <>
    {prompts.map((definition) => (
      <VisualPromptCard
        key={definition.id}
        definition={definition}
        onSelect={onSelectPrompt}
        onDelete={onDeletePrompt}
        onToggleFeatured={onToggleFeatured}
      />
    ))}
  </>
);
